import { useEffect, useState } from "react";
import moment from "moment";
import {format} from 'date-fns';
import { Image } from "@fluentui/react-components";

import { ResourceSpaceType } from "../../APIService/ResourceSpaceTypeListService";
import { UserBooking } from "../../APIService/UserBookingService";
import { BookingCardAction } from "./work_place";
import { CommonInfo } from "../../CommonData/Config";
import ResourceSpaceList from "../ResourceSpaceType/ResourceSpaceTypeList";
import BookingCard from "./BookingCard";
import { useTranslation } from "react-i18next";

type UserBookingsProps = {
  theme: string | null;
  dateFormat : string;
  selectedDate : Date;
  resourceSpaceData: ResourceSpaceType[];
  userBookings: UserBooking[];
  onDateChange: (date: Date) => void;
  onSpaceTypeSelect: (item: ResourceSpaceType) => void;
  onBookingCardAction: (index: number, bookingData: UserBooking, action: BookingCardAction) => void;
};

const UserBookings = ({ theme, dateFormat, selectedDate, resourceSpaceData, userBookings, onDateChange, onSpaceTypeSelect, onBookingCardAction}: UserBookingsProps) => {


    const {t} = useTranslation();
    const [bookingDate, setBookingDate] = useState<Date>(new Date());
    const isToday = moment(bookingDate).isSame(moment(), 'day');

    useEffect(() => {
        if (bookingDate !== selectedDate) {
            setBookingDate(selectedDate);
        }
    }, [selectedDate]);

    const handlePrevDay = () => {
        updateDate(moment(bookingDate).subtract(1, "day").toDate());
    };

    const handleNextDay = () => {
        updateDate(moment(bookingDate).add(1, "day").toDate());
    };

    const handleTodayClick = () => {
        updateDate(new Date());
    };

    const updateDate = (newDate: Date) => {
        setBookingDate(newDate);
        onDateChange(newDate);
    };

    return (
        <>

            <div className="col-md-12 ">
                <label className={theme === 'dark' ? 'head_dark' : 'head'}>{t('Bookings')}</label>
                <hr/>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-3">
            <div className="d-flex align-items-center ms-1">  
             <img
                id="button_icon"
                style={{ width: "20px" }}
                className='pointer'
                src={`${CommonInfo.folderName}${theme === 'dark' ? '/Calandarlight.svg' : '/datepicker.svg'}`}
                alt="Calendar Icon"
            />
            <span  className={theme === 'dark' ? 'span_head ps-2 date pointer' : 'date pointer'}>
                 {/* {moment(bookingDate).format(dateFormat ? dateFormat : 'dddd DD MMMM YYYY')} */}
                 {format(bookingDate,"do MMMM yyyy")}
                 </span>
            </div>  
            
            <span>
                <Image onClick={handlePrevDay}  className={theme === 'dark' ? 'pointer img_hover' : 'pointer img_hover_light'} src={`${CommonInfo.folderName}${theme === 'dark' ? '/leftarrowlight.svg' : '/leftarrow.svg'}`}/>&nbsp;&nbsp;&nbsp;&nbsp;
                <Image onClick={handleNextDay}  className={theme === 'dark' ? 'pointer img_hover' : 'pointer img_hover_light'} src={`${CommonInfo.folderName}${theme === 'dark' ? '/rightarrowlight.svg' : '/rightarrow.svg'}`} />
            </span>

            {
                !isToday && (
                    <div>
                        <button className={theme === 'dark' ? 'calendar_btn_dark' : 'calendar_btn'} onClick={handleTodayClick}>
                        <img
                            id="button_icon"
                            style={{ width: "20px" }}
                            className='pointer'
                            src={`${CommonInfo.folderName}${theme === 'dark' ? '/Calandarlight.svg' : '/datepicker.svg'}`}
                            alt="Calendar Icon"
                        />
                         &nbsp;&nbsp;{t("Today")}
                        </button>
                    </div>
                )
            }
            
            {resourceSpaceData.length > 0 && (
                <div className='resourceSpaceList'>
                    <ResourceSpaceList theme={theme} resourceSpaceData={resourceSpaceData} onSelect={onSpaceTypeSelect}/>
                </div>
            )}

            {userBookings.map((booking: UserBooking,index:number) => (
                <BookingCard key={index} booking={booking} theme={theme} onAction={(action) => onBookingCardAction(index, booking, action)}/>
            ))}
            </div>
            
        </>
    )
}

export default UserBookings;